import {Routes} from '@angular/router';

import {canActivateGuard} from '../../guards/can-activate-guard';
import {PERMISSION} from '@generated-backend-types';
import {IndexComponent as InquiriesIndexComponent} from './index/index.component';

export const routes: Routes = [
  {
    path: '',
    component: InquiriesIndexComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [
        PERMISSION.PATIENT_READ_ALL,
        PERMISSION.INQUIRY_INQUIRY_READ_ALL,
      ],
      breadcrumb: [
        {
          label: 'authenticated.inquiries.index.breadcrumb',
          translate: true,
          route: '/inquiries'
        },
      ]
    }
  },
];
